import { DATA_CACHE_SIZE, FILE_LOCKING_EXTENSIONS, MOUNT_POINT_WINDOWS, } from '@lucidlink/sdk';
import { FILESPACE_SETTING_CHANGED_EVENT_NAME, hasSpecializedEvent, LockingExtensionChange, MOUNT_POINT_TYPE_LETTER, MountPointType, SettingNameToSpecializedEventName, SettingScope, } from './constants';
const inferMountType = (mountPoint) => {
    if (mountPoint.startsWith('\\\\')) {
        return MountPointType.UNC;
    }
    else if (MOUNT_POINT_TYPE_LETTER.test(mountPoint)) {
        return MountPointType.LETTER;
    }
    else {
        return MountPointType.PATH;
    }
};
const getParams = (updatedSetting, context) => {
    switch (updatedSetting.fullName) {
        case DATA_CACHE_SIZE: {
            const sizeBefore = context.sizeBefore;
            const sizeAfter = updatedSetting.value;
            return {
                oldCacheSize: sizeBefore,
                newCacheSize: sizeAfter,
            };
        }
        case MOUNT_POINT_WINDOWS:
            return {
                mountPointType: inferMountType(updatedSetting.value),
            };
        default:
            throw new Error('Unreachable!');
    }
};
const diffExtensionList = (currList, updatedList) => {
    const oldSet = new Set(currList);
    const newSet = new Set(updatedList);
    const extensionsAdded = updatedList.filter((item) => !oldSet.has(item));
    const extensionsRemoved = currList.filter((item) => !newSet.has(item));
    return { extensionsAdded, extensionsRemoved };
};
const buildLockingExtensionChangedEvent = (extension, changeType) => ({
    name: SettingNameToSpecializedEventName[FILE_LOCKING_EXTENSIONS],
    data: {
        customData: {
            changeType: changeType,
            extensionName: extension,
        },
    },
});
const buildExtensionAddedEvent = (extension) => buildLockingExtensionChangedEvent(extension, LockingExtensionChange.ADD);
const buildExtensionRemovedEvent = (extension) => buildLockingExtensionChangedEvent(extension, LockingExtensionChange.REMOVE);
const makeLockingExtensionChangedEvents = (updatedSetting, context) => {
    const currentExtensionList = context.extensionsBefore.split(',');
    const updatedExtensionList = updatedSetting.value.split(',');
    const { extensionsAdded, extensionsRemoved } = diffExtensionList(currentExtensionList, updatedExtensionList);
    return [
        ...extensionsAdded.map(buildExtensionAddedEvent),
        ...extensionsRemoved.map(buildExtensionRemovedEvent),
    ];
};
const makeEvents = (updatedSetting, context) => {
    const fullName = updatedSetting.fullName;
    if (!hasSpecializedEvent(fullName)) {
        return [];
    }
    if (fullName === FILE_LOCKING_EXTENSIONS) {
        return makeLockingExtensionChangedEvents(updatedSetting, context);
    }
    return [
        {
            name: SettingNameToSpecializedEventName[fullName],
            data: {
                customData: {
                    settingType: SettingScope.GLOBAL,
                    ...getParams(updatedSetting, context),
                },
            },
        },
    ];
};
const makeFilespaceSettingChangeEvent = (updatedSetting) => ({
    name: FILESPACE_SETTING_CHANGED_EVENT_NAME,
    data: {
        customData: {
            settingType: SettingScope.GLOBAL,
            settingName: updatedSetting.fullName,
        },
    },
});
const composeEvents = (updatedSetting, context) => [
    makeFilespaceSettingChangeEvent(updatedSetting),
    ...makeEvents(updatedSetting, context),
];
export const composeTelemetry = (updatedSettings, context) => updatedSettings.flatMap((update) => composeEvents(update, context));
